import OpenStreetMapAddress from '@/classes/addresses/OpenStreetMapAddress'

export default class OpenStreetMapAddresses extends Array {
  constructor (addresses, ...rest) {
    Array.isArray(addresses) ? super(...addresses.filter(({ lat, lon }) => lat && lon).map(address => new OpenStreetMapAddress(address))) : super(...rest)
  }

  getByType (type) {
    return this.filter(address => !type || address.types.includes(type))
  }
}
